var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, } from "react";
import styled from "styled-components";
import "focus-visible";
import { apolloFontFamilyBodySmall, apolloFontSizeBodySmall, apolloSpaceInset2X, apolloSpaceInset1X, apolloSpaceInsetHalfX, apolloSpaceInline1X, apolloSpaceStackHalfX, apolloSpaceStack1X, } from "@nexthink/apollo-tokens";
import { trapEvent } from "../../utils/EventHelpers";
import Icon from "../icons/Icon";
import { variant } from "styled-system";
import Checkbox from "../checkbox/Checkbox";
import Flex from "../box/Flex";
import { StyledSelectPreview } from "../select/SelectPreview";
import { Text } from "../text";
export const heightMedium = 24;
export const heightSmall = 16;
const focusAndHoverStyle = (theme, isSelected, expandableContent, multiSelect, disabled) => (Object.assign(Object.assign(Object.assign({ background: isSelected && !expandableContent && !multiSelect
        ? theme.colors.apolloColorBackgroundMenuItemSelected
        : theme.colors.apolloColorBackgroundMenuItemHover }, (disabled &&
    (multiSelect || !isSelected) && {
    background: "none",
})), { [StyledDescriptionFlex]: {
        opacity: 1,
        width: "auto",
        marginRight: apolloSpaceStackHalfX,
        [StyledDescriptionIcon]: {
            display: "block",
        },
    } }), (!isSelected &&
    !disabled && {
    [StyledSelectPreview]: {
        borderColor: theme.colors.apolloColorStrokeFormElementHover,
    },
})));
const StyledArrowIcon = styled((_a) => {
    var { selected, disabled } = _a, rest = __rest(_a, ["selected", "disabled"]);
    return (React.createElement(Icon, Object.assign({ name: selected ? "angleDown" : "angleRight", "aria-hidden": "true" }, rest)));
}).withConfig({ displayName: "StyledArrowIcon_APC-7281-productShell", componentId: "sc-124ma2r" })(({ theme, disabled }) => (Object.assign(Object.assign({ fontSize: "16px", marginLeft: apolloSpaceInline1X }, (disabled && { color: theme.colors.apolloColorTextDisabled })), { overflow: "hidden !important", width: "16px !important" })));
export const StyledExpandableContent = styled.div.withConfig({ displayName: "StyledExpandableContent_APC-7281-productShell", componentId: "sc-1rj0tl" })(({ "aria-hidden": ariaHidden }) => ({
    display: ariaHidden ? "none" : "block",
    overflow: "hidden",
}));
const StyledCheckbox = styled(Checkbox).withConfig({ displayName: "StyledCheckbox_APC-7281-productShell", componentId: "sc-l7uvm2" })({
    visibility: "hidden",
});
export const StyledDescriptionIcon = styled(Icon).withConfig({ displayName: "StyledDescriptionIcon_APC-7281-productShell", componentId: "sc-5i9fyn" })({
    "&&": {
        fontSize: "1rem",
        width: "1rem",
        display: "none",
    },
});
export const StyledDescriptionFlex = styled(Flex).withConfig({ displayName: "StyledDescriptionFlex_APC-7281-productShell", componentId: "sc-1tfw121" })({
    opacity: 0,
    width: 0,
    marginRight: 0,
    "&&:focus-visible, &:hover": {
        opacity: 1,
        width: "1rem",
        marginRight: apolloSpaceStackHalfX,
        [StyledDescriptionIcon]: {
            display: "block",
        },
    },
});
export const RightTextWrapper = styled(Flex).withConfig({ displayName: "RightTextWrapper_APC-7281-productShell", componentId: "sc-ex21lm" })(({ extraTextMaxWidth = "50%" }) => ({
    maxWidth: extraTextMaxWidth,
    marginLeft: "auto",
    marginRight: 0,
}));
export const StyledExtraText = styled(Text).withConfig({ displayName: "StyledExtraText_APC-7281-productShell", componentId: "sc-16d51uu" })(({ theme, isSelected }) => ({
    paddingLeft: apolloSpaceStack1X,
    color: isSelected ? theme.colors.apolloColorTextPrimaryOnDark : theme.colors.apolloColorTextSecondary,
    textOverflow: "ellipsis",
    overflow: "hidden",
    marginRight: apolloSpaceStackHalfX,
}));
export const StyledItemLabel = styled.span.withConfig({ displayName: "StyledItemLabel_APC-7281-productShell", componentId: "sc-1cb3zzj" })(() => ({
    flex: 1,
}));
export const StyledTextContainer = styled.span.withConfig({ displayName: "StyledTextContainer_APC-7281-productShell", componentId: "sc-ngers9" })(({ isContentWidth }) => (Object.assign({ display: "flex !important" }, (!isContentWidth && {
    width: "100%",
}))));
export const StyledMenuItem = styled(
// the function StyleMenuItem instead of arrow function is to avoid issue with eslint display name missing
// https://github.com/yannickcr/eslint-plugin-react/issues/2269
forwardRef(function StyledMenuItem(_a, ref) {
    var { children, isSelected, expandableContent, multiSelect, id, variant: menuItemVariant, description, disabled, extraText, extraTextMaxWidth, isContentWidth } = _a, rest = __rest(_a, ["children", "isSelected", "expandableContent", "multiSelect", "id", "variant", "description", "disabled", "extraText", "extraTextMaxWidth", "isContentWidth"]);
    return expandableContent ? (
    // display list item with arrow icon to expand the content
    React.createElement("li", Object.assign({}, (menuItemVariant !== "timeframepicker" && {
        role: "menuitem",
        "aria-expanded": isSelected,
        "aria-disabled": disabled,
        "aria-controls": `${id}-content`,
    }), { tabIndex: 0 }, rest, { ref: ref }),
        React.createElement("span", { style: { display: "flex" } },
            React.createElement("span", null, children),
            " ",
            React.createElement(StyledArrowIcon, { selected: isSelected, disabled: disabled })),
        isSelected && (React.createElement(StyledExpandableContent, { id: `${id}-content`, "aria-hidden": !isSelected, "aria-disabled": disabled, onClick: (e) => trapEvent(e) }, expandableContent)))) : (React.createElement("li", Object.assign({}, (menuItemVariant !== "timeframepicker" && {
        role: menuItemVariant === "select" ? "option" : multiSelect ? "menuitemcheckbox" : "menuitemradio",
        "aria-checked": isSelected,
    }), (menuItemVariant === "timeframepicker" && {
        "aria-current": isSelected,
    }), (disabled && { "aria-disabled": true }), (!disabled && { tabIndex: 0 }), { id: id }, rest, { ref: ref }),
        React.createElement(StyledTextContainer, { isContentWidth: isContentWidth },
            multiSelect && (React.createElement(StyledCheckbox, { name: "selectItem", id: `${id}-checkbox`, onChange: () => undefined, checked: isSelected, disabled: disabled, "aria-checked": isSelected, "aria-labelledby": `${id}-checkbox-label` })),
            React.createElement(StyledItemLabel, { id: `${id}-checkbox-label` }, children)),
        React.createElement(RightTextWrapper, { alignItems: "center", extraTextMaxWidth: extraTextMaxWidth, mr: apolloSpaceInsetHalfX },
            extraText && (React.createElement(StyledExtraText, { isSelected: isSelected, "aria-label": `${id}-extraText` }, extraText)),
            description && (React.createElement(StyledDescriptionFlex, { alignItems: "center", mr: apolloSpaceInsetHalfX },
                React.createElement(StyledDescriptionIcon, { name: "infoSmall" }))))));
})).withConfig({ displayName: "StyledMenuItem_APC-7281-productShell", componentId: "sc-44yjqd" })(({ theme, isSelected, expandableContent, size, multiSelect, disabled }) => ({
    color: disabled ? theme.colors.apolloColorTextDisabled : theme.colors.apolloColorTextPrimary,
    cursor: disabled ? "default" : "pointer",
    fontFamily: apolloFontFamilyBodySmall,
    fontSize: apolloFontSizeBodySmall,
    paddingTop: `calc(${apolloSpaceInsetHalfX} - 1px)`,
    paddingBottom: `calc(${apolloSpaceInsetHalfX} - 1px)`,
    whiteSpace: "nowrap",
    minHeight: `${size === "medium" ? heightMedium : heightSmall}px`,
    "& > span": {
        boxSizing: "border-box",
        border: `1px solid transparent`,
        lineHeight: `${size === "medium" ? heightMedium : heightSmall}px`,
        padding: `0px calc(${apolloSpaceInsetHalfX} - 1px)`,
    },
    display: expandableContent ? "block" : "flex",
    position: "relative",
    // hover & focus state
    [`&:hover`]: Object.assign({}, focusAndHoverStyle(theme, isSelected, expandableContent, multiSelect, disabled)),
    // used to create the focus ring
    "& > span, & > span > span": {
        position: "relative",
        alignItems: "center",
        display: "inline-block",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
    // margin for checkbox
    "& > span > span": {
        marginLeft: multiSelect ? apolloSpaceInline1X : 0,
    },
    // display focus ring (simulation of outside-offset) when using keyboard
    "&:focus-visible, &[data-focus-visible-added]": Object.assign({ 
        // remove global style for focus ring
        boxShadow: "none !important", outline: "none !important" }, focusAndHoverStyle(theme, isSelected, expandableContent, multiSelect, disabled)),
}), ({ theme, isSelected, multiSelect, description, expandableContent }) => (Object.assign(Object.assign(Object.assign({}, (!!isSelected &&
    !multiSelect && {
    background: theme.colors.apolloColorBackgroundMenuItemSelected,
    color: theme.colors.apolloColorTextPrimaryOnDark,
    [StyledSelectPreview]: {
        borderColor: theme.colors.apolloColorStrokeFocusOnDark,
    },
})), (description &&
    !!isSelected &&
    !multiSelect && {
    [`& ${StyledDescriptionFlex} ${StyledDescriptionIcon}`]: {
        background: theme.colors.apolloColorBackgroundMenuItemSelected,
        color: theme.colors.apolloColorTextPrimaryOnDark,
    },
})), (!!isSelected &&
    !!expandableContent && {
    background: theme.colors.apolloColorBackgroundMenuItemHover,
    color: theme.colors.apolloColorTextPrimary,
    [`& > ${StyledExpandableContent}`]: {
        padding: `0px ${apolloSpaceInsetHalfX}`,
        paddingTop: apolloSpaceInset1X,
    },
}))), () => variant({
    prop: "variant",
    variants: {
        classic: {
            paddingLeft: `calc(${apolloSpaceInset2X} - ${apolloSpaceInsetHalfX})`,
            paddingRight: `calc(${apolloSpaceInset2X} - ${apolloSpaceInsetHalfX})`,
        },
        select: {
            paddingLeft: `calc(${apolloSpaceInset1X} - ${apolloSpaceInsetHalfX})`,
            paddingRight: `calc(${apolloSpaceInset1X} - ${apolloSpaceInsetHalfX})`,
        },
        timeframepicker: {
            paddingLeft: `calc(${apolloSpaceInset2X} - ${apolloSpaceInsetHalfX})`,
            paddingRight: `calc(${apolloSpaceInset2X} - ${apolloSpaceInsetHalfX})`,
        },
    },
}));
export const StyledMenuItemWrapper = styled.div.withConfig({ displayName: "StyledMenuItemWrapper_APC-7281-productShell", componentId: "sc-g3cy2t" })({ position: "relative" });
//# sourceMappingURL=MenuItem.style.js.map